export class GstTaxQueryParameters {
  endDate?: Date;
  id?: string;
  gstPercent?: number;
  page?: number;
  pageSize?: number;
  startDate?: Date;

  constructor(obj?: GstTaxQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
